<template>
  <app-login />
</template>

<script>
import Login from './components/Login.vue'

export default {
  components: {
    appLogin : Login
  }
}
</script>

<style>
  @import 'assets/css/util.css';
  @import 'assets/css/main.css';
</style>
